import Vue from 'vue'
import Vuex from 'vuex'

/* Theme Core */
import corporatePoliciesType from '@/store/Admin/App/corporate_policies_type'
import verticalMenu from './vertical-menu'
import appConfig from './app-config'
import app from './app'
/* App Core */
import users from './Admin/Core/users'
import userTypes from './Admin/Core/user_types'
import smtpConfig from './Admin/Core/smtpconfig'
import abilities from './Admin/Core/abilities'
import cropperUploads from './Admin/Core/cropper_uploads'
import fileUpload from './Admin/Core/file_upload'
/* App Data */
import about from './Admin/App/about'
import aboutCounter from './Admin/App/about_counter'
import aboutCounterItems from './Admin/App/about_counter_items'
import homePage from './Admin/App/home_page'
import blog from './Admin/App/blog'
import blogCategories from './Admin/App/blog_categories'
import carousel from './Admin/App/carousel'
import certificates from './Admin/App/certificates'
import components from './Admin/App/components'
import contacts from './Admin/App/contacts'
import contents from './Admin/App/contents'
import corporatePolicies from './Admin/App/corporate_policies'
import corporatePoliciesItems from './Admin/App/corporate_policies_items'
import corporatePoliciesCategories from './Admin/App/corporate_policies_categories'
import footerContacts from './Admin/App/footer_contacts'
import modLeads from './Admin/App/mod_leads'
import laboratory from './Admin/App/Laboratory'
import laboratoryPolicy from './Admin/App/laboratoryPolicy'
import laboratoryServiceTerms from './Admin/App/laboratoryServiceTerms'
import laboratoryServices from './Admin/App/laboratoryServices'
import laboratoryEducations from './Admin/App/laboratoryEducations'
import laboratoryForms from './Admin/App/laboratoryForms'
import menus from './Admin/App/menus'
import products from './Admin/App/products'
import productCategories from './Admin/App/product_categories'
import productItems from './Admin/App/product_items'
import socialMedia from './Admin/App/socialmedia'
import siteConfig from './Admin/App/site_config'
import translate from './Admin/App/translate'
import cacheParams from './Admin/App/cache_params'
import references from './Admin/App/references'
import webforms from './Admin/App/webforms'
/* App Defines */
import menuTypes from './Admin/Defines/menu_types'
import productConfig from './Admin/Defines/product_config'
import tableColors from './Admin/Defines/table_colors'
import vehicleTypes from './Admin/Defines/vehicle_types'
import webformDepartments from './Admin/Defines/webform_departments'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    users,
    userTypes,
    smtpConfig,
    abilities,
    cropperUploads,
    fileUpload,
    about,
    aboutCounter,
    aboutCounterItems,
    homePage,
    blog,
    blogCategories,
    carousel,
    certificates,
    corporatePolicies,
    corporatePoliciesItems,
    corporatePoliciesCategories,
    corporatePoliciesType,
    footerContacts,
    components,
    contacts,
    contents,
    laboratory,
    laboratoryPolicy,
    laboratoryServiceTerms,
    laboratoryServices,
    laboratoryEducations,
    laboratoryForms,
    menus,
    modLeads,
    socialMedia,
    siteConfig,
    translate,
    menuTypes,
    products,
    productCategories,
    productItems,
    productConfig,
    tableColors,
    vehicleTypes,
    webformDepartments,
    cacheParams,
    references,
    webforms,
  },
  strict: process.env.DEV,
})
